import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { renewalPath } from './paths'

type RenewalTopStripProps = {
  tone?: 'default' | 'snack'
  text?: string
  linkText?: string
  href?: string
}

export default function RenewalTopStrip({
  tone = 'default',
  text = '신청만 해 주시면 담당 매니저가 먼저 매장을 보고, 우리 매장 체크리스트를 만들어 드려요',
  linkText = '1:1 상담하기',
  href = renewalPath('/apply'),
}: RenewalTopStripProps) {
  return (
    <Strip $tone={tone}>
      <Inner>
        <StripText>{text}</StripText>
        <StripLinkView href={href} tone={tone}>
          {linkText}
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true">
            <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </StripLinkView>
      </Inner>
    </Strip>
  )
}

const Strip = styled.div<{ $tone: 'default' | 'snack' }>`
  background: ${({ $tone }) => ($tone === 'snack' ? '#5c0614' : '#0c2049')};
  color: rgba(255, 255, 255, 0.88);
  font-size: 15px;
  font-weight: 600;
  line-height: 1.45;
`

const Inner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  min-height: 44px;
  padding: 0 clamp(20px, 3.4vw, 40px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 14px;
  text-align: center;
`

const StripText = styled.span`
  padding: 8px 0;
`

const linkCss = css<{ $tone: 'default' | 'snack' }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 44px;
  color: ${({ $tone }) => ($tone === 'snack' ? '#ffc9d2' : '#ffb649')};
  font-weight: 700;

  &:hover {
    color: #ffffff;
  }
`

const StripLink = styled(Link)<{ $tone: 'default' | 'snack' }>`
  ${linkCss}
`

const StripAnchor = styled.a<{ $tone: 'default' | 'snack' }>`
  ${linkCss}
`

function StripLinkView({ href, tone, children }: { href: string; tone: 'default' | 'snack'; children: ReactNode }) {
  if (/^https?:/.test(href)) {
    return (
      <StripAnchor href={href} $tone={tone} target="_blank" rel="noopener">
        {children}
      </StripAnchor>
    )
  }
  return (
    <StripLink to={href} $tone={tone}>
      {children}
    </StripLink>
  )
}
